// Workflow Constants - Constantes compartidas del editor de workflows
import { MarkerType } from '@xyflow/react';
import type { ActionConfig } from '../types/workflow';

/**
 * H-F026/H-F027: Dimensiones estándar de nodos en el canvas.
 * Usar estas constantes en nodeAlignment.ts y loopAutoLayout.ts
 * para evitar valores hardcodeados duplicados.
 */
export const NODE_WIDTH = 200;
export const NODE_HEIGHT = 80;

// Color compartido para edges (evita hardcodeo en inline styles)
export const EDGE_COLOR = '#6b7280';

/**
 * Tipos de accion validos para nodos ejecutables.
 * Fuente de verdad unica — usar en validador, transformer y cualquier lugar
 * que necesite verificar si un actionType es conocido.
 */
export const VALID_ACTION_TYPES = ['click', 'type', 'extract', 'read-text', 'navigate', 'wait', 'keys', 'open-app', 'select-grid-row'] as const;
export type ValidActionType = typeof VALID_ACTION_TYPES[number];

export const DEFAULT_EDGE_OPTIONS = {
  type: 'smoothstep' as const,
  animated: true,
  markerEnd: {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color: EDGE_COLOR,
  },
  style: {
    strokeWidth: 2,
    stroke: EDGE_COLOR,
  },
};

/**
 * Crea la configuracion inicial de un nodo segun su tipo de accion.
 */
export function createInitialConfig(actionType: string, label: string): ActionConfig {
  const baseConfig = { type: actionType, label };
  switch (actionType) {
    case 'type':
      return { ...baseConfig, type: 'type', selector: '', text: '', clearBefore: true };
    case 'click':
      return { ...baseConfig, type: 'click', selector: '', clickType: 'left' };
    case 'wait':
      return { ...baseConfig, type: 'wait', waitType: 'time', duration: 1 };
    case 'navigate':
      return { ...baseConfig, type: 'navigate', url: '' };
    case 'extract':
      return { ...baseConfig, type: 'extract', selector: '', variableName: '' };
    case 'loop':
      return { ...baseConfig, type: 'loop', loopMode: 'excel', dataSource: '', iterationVariable: 'fila' };
    case 'if-else':
      return { ...baseConfig, type: 'if-else', conditionMode: 'variable', condition: '', operator: '==' };
    case 'read-text':
      return { ...baseConfig, type: 'read-text', selector: '', variableName: '' };
    case 'keys':
      return { ...baseConfig, type: 'keys', mode: 'simple', modifiers: [], key: '', repeatCount: 1, repeatDelay: 100 };
    case 'open-app':
      return { ...baseConfig, type: 'open-app', appPath: '', timeout: 30, useExisting: false };
    case 'select-grid-row':
      return { ...baseConfig, type: 'select-grid-row', gridSelector: '', searchColumn: '', searchValue: '', clickType: 'double', matchMode: 'contains' };
    default:
      return baseConfig as ActionConfig;
  }
}
